
import { defineComponent, ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { mapState, useStore } from 'vuex'

import Swiper from 'swiper/swiper-bundle'

import 'swiper/swiper-bundle.css'

export default defineComponent({
    setup (props, context) {
        const $store = useStore()
        const activeIndex = ref<number>(0)
        let lineSwiper = null as any
        let list = [
            {
                img: require('@/assets/img/line_01.jpg'),
                title: '文艺青年路线'
            },
            {
                img: require('@/assets/img/line_02.jpg'),
                title: '潮玩路线'
            },
            {
                img: require('@/assets/img/line_03.jpg'),
                title: '文艺青年路线'
            },
            {
                img: require('@/assets/img/line_04.jpg'),
                title: '美食专家路线'
            },
            {
                img: require('@/assets/img/line_05.jpg'),
                title: '成都旅游达人路线'
            },
            {
                img: require('@/assets/img/line_06.jpg'),
                title: '成都旅游达人路线'
            },
            {
                img: require('@/assets/img/line_07.jpg'),
                title: '浪漫达人路线'
            },
            {
                img: require('@/assets/img/line_08.jpg'),
                title: '浪漫达人路线'
            },
            {
                img: require('@/assets/img/line_09.jpg'),
                title: '文艺青年路线'
            },
            {
                img: require('@/assets/img/line_10.jpg'),
                title: '特种兵路线'
            }
        ]

        const close = () => {
            $store.commit('SET_LINESHOW', false)
        }

        const initSwiper = () => {
            lineSwiper = new Swiper('.line-swiper', {
                effect : 'coverflow',
                slidesPerView: 'auto',
                centeredSlides: true,
                initialSlide: 0,
                coverflowEffect: {
                    rotate: 0,
                    stretch: '35.7%',
                    depth: 60,
                    modifier: 2,
                    slideShadows : true
                },
                on: {
                    slideChangeTransitionEnd () {
                        activeIndex.value = lineSwiper.activeIndex
                    }
                },
            })
        }

        const prev = () => {
            lineSwiper.slidePrev()
        }

        const next = () => {
            lineSwiper.slideNext()
        }

        onBeforeUnmount(() => {
            lineSwiper && lineSwiper.destroy()
        })

        onMounted(() => {
            nextTick(() => {
                initSwiper()
            })
        })

        return {
            activeIndex,
            list,
            close,
            prev,
            next
        }
    }
})
